import React from 'react'
import Typography from '@material-ui/core/Typography'
import FormattedMessageWithBold from '../../../../../components/FormattedMessageWithBold'
import { getDureeCalculee } from '../../form/CreerTache'
import { EMPTY_VALUE, TYPE_SURFACE } from '../../../../../utils/constants'
import PropTypes from 'prop-types'

/**
 * Composant pour afficher la durée en fonction des surfaces sélectionnées
 * @param modele le modèle de tâche sélectionnée
 * @param surfaceValue le code de la surface
 * @param planches les planches sélectionnées
 * @param formattedMessageBase id message de base
 * @returns {Element}
 */
const TacheDuree = ({ surfaceValue, modele, planches, formattedMessageBase }) => {
	// si on sélectionne une seule surface, alors on calcule la durée en minute
	if (surfaceValue?.length === 1 && surfaceValue[0].code !== EMPTY_VALUE && surfaceValue[0].type === TYPE_SURFACE.PLANCHE) {
		return (<Typography>
			<FormattedMessageWithBold
				id={`${formattedMessageBase}.detail.duree`}
				values={{ duree: getDureeCalculee(modele, planches, surfaceValue[0].code) }}
			/>
		</Typography>)
	} else if (modele.tempsMoyM2 != null && modele.tempsMoyFixe == null) { // si elle existe, on affiche la durée en min/m2 du modèle de tâche
		return (<Typography>
			<FormattedMessageWithBold
				id={`${formattedMessageBase}.detail.dureeMinM2`}
				values={{ duree: modele.tempsMoyM2 }}
			/>
		</Typography>)
	} else { // sinon la durée en min du modèle de tâche
		return (<Typography>
			<FormattedMessageWithBold
				id={`${formattedMessageBase}.detail.duree`}
				values={{ duree: modele.tempsMoyFixe }}
			/>
		</Typography>)
	}
}

TacheDuree.propTypes = {
	surfaceValue: PropTypes.arrayOf(
		PropTypes.shape({
			code: PropTypes.string,
			label: PropTypes.string,
			type: PropTypes.string
		})
	),
	planches: PropTypes.arrayOf(
		PropTypes.shape({
			bloc: PropTypes.string,
			commentaires: PropTypes.array,
			dateDebutIndisponibilite: PropTypes.string,
			dateFinIndisponibilite: PropTypes.string,
			id: PropTypes.string,
			idFerme: PropTypes.string,
			inactive: PropTypes.bool,
			indisponible: PropTypes.bool,
			largeur: PropTypes.number,
			longueur: PropTypes.number,
			nom: PropTypes.string,
			surface: PropTypes.number,
			typePlanche: PropTypes.string,
			zone: PropTypes.string
		})
	),
	modele: PropTypes.shape({
		categorieTechnique: PropTypes.object,
		codeTache: PropTypes.string,
		competences: PropTypes.array,
		creationSemaineN: PropTypes.number,
		culture: PropTypes.string,
		dateCreation: PropTypes.string,
		dateModification: PropTypes.string,
		debutFin: PropTypes.bool,
		description: PropTypes.string,
		etape: PropTypes.string,
		familleTache: PropTypes.string,
		flagAnticipable: PropTypes.bool,
		flagControleEtape: PropTypes.bool,
		flagCreationAssolement: PropTypes.bool,
		flagCreationCampagne: PropTypes.bool,
		flagDivisible: PropTypes.bool,
		flagRecurrence: PropTypes.bool,
		id: PropTypes.string,
		idFerme: PropTypes.string,
		idItkDetail: PropTypes.string,
		idMoTachePrecedente: PropTypes.string,
		idRecurrence: PropTypes.string,
		idTacheGenerique: PropTypes.string,
		isTacheGenerique: PropTypes.bool,
		itk: PropTypes.object,
		itkDetail: PropTypes.object,
		joursAnticipable: PropTypes.number,
		materiels: PropTypes.array,
		nbPersonnes: PropTypes.number,
		pourcentageRecolte: PropTypes.number,
		priorite: PropTypes.number,
		recurrence: PropTypes.object,
		reglages: PropTypes.array,
		sensibilites: PropTypes.array,
		tempsMoyFixe: PropTypes.number,
		tempsMoyM2: PropTypes.number,
		timeline: PropTypes.number,
		typeEntity: PropTypes.string,
		typeTache: PropTypes.string,
		urlDocInstruction: PropTypes.string,
		userCreation: PropTypes.string,
		userModification: PropTypes.string
	}),
	formattedMessageBase: PropTypes.string
}

export default TacheDuree